<ng-container *transloco="let t">
  <div class="flex w-[50rem] flex-col gap-4">
    <p>
      {{ t("remove-ia-powered-targeting-popup.deletion_confirm") }}
    </p>
  </div>
  <div class="flex justify-end gap-2">
    <IButton label="{{ t('common.cancel') }}" color="gray" variant="ghost" (onClick)="modalRef.close()" />
    <IButton label="{{ t('common.delete') }}" color="red" (onClick)="delete()" />
  </div>
</ng-container>
